import { render, staticRenderFns } from "./recommand.vue?vue&type=template&id=8d7e9934"
import script from "./recommand.vue?vue&type=script&lang=js"
export * from "./recommand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports